import {
  ACTIVE_USERS,
  ACTIVE_USERS_ADDED,
  CATALOG_TOTAL_METRIC,
  COLLECTION_REFERENCES,
  CURRENT_CUSTOM_EVENTS_STORED,
  CURRENT_USERS,
  CUSTOM_EVENTS_STORED,
  EMAILS_SENT,
  IN_APP_NOTIFICATIONS_SENT,
  LOOKUP_REFERENCES,
  MMS_ATTACHMENTS_RECEIVED,
  MMS_ATTACHMENTS_SENT,
  MMS_ATTACHMENTS_TOTAL,
  PRODUCT_RECOMMENDATIONS,
  PUSH_NOTIFICATIONS_SENT,
  SMART_INGEST_METRICS,
  SMS_SEGMENTS_RECEIVED,
  SMS_SEGMENTS_SENT,
  SMS_SEGMENTS_TOTAL,
  SMS_SENT,
  SUCCESSFUL_SMS_VERIFICATIONS,
  USERS,
  USERS_ADDED,
  WEB_PUSH_NOTIFICATIONS_SENT,
  WHATSAPP_SENT,
} from './metricNames';

export const PROJECT_BREAKDOWN_BREADCRUMB = {
  content: 'Usage and Billing',
  href: '/payments/info',
};

export const COLUMN_DEFAULTS = {
  align: 'center',
  sortable: true,
};

export const PROJECT_NAME_COLUMN_VALUE = 'projectName';
export const PROJECT_NAME_COLUMN_LABEL = 'Project name';
export const PROJECT_COLUMN = { value: PROJECT_NAME_COLUMN_VALUE, name: PROJECT_NAME_COLUMN_LABEL };

export const ORG_ROW_NAME = 'Organization usage';

export const DEFAULT_FILTER_OPTIONS = {
  isSelectMenu: true,
};

export const PROJECT_BREAKDOWN_COLUMN_ORDERING: Record<string, number> = {
  // Messaging
  [EMAILS_SENT]: 0,
  [SMS_SENT]: 1,
  [PUSH_NOTIFICATIONS_SENT]: 2,
  [WEB_PUSH_NOTIFICATIONS_SENT]: 3,
  [IN_APP_NOTIFICATIONS_SENT]: 4,
  [SMS_SEGMENTS_SENT]: 5,
  [SMS_SEGMENTS_RECEIVED]: 6,
  [SMS_SEGMENTS_TOTAL]: 7,
  [MMS_ATTACHMENTS_SENT]: 8,
  [MMS_ATTACHMENTS_RECEIVED]: 9,
  [MMS_ATTACHMENTS_TOTAL]: 10,
  [SUCCESSFUL_SMS_VERIFICATIONS]: 11,
  [WHATSAPP_SENT]: 12,
  // Users
  [CURRENT_USERS]: 0,
  [USERS]: 1,
  [USERS_ADDED]: 2,
  [ACTIVE_USERS]: 3,
  [ACTIVE_USERS_ADDED]: 4,
  // Custom events
  [CURRENT_CUSTOM_EVENTS_STORED]: 0,
  [CUSTOM_EVENTS_STORED]: 1,
  // Catalog
  [CATALOG_TOTAL_METRIC]: 0,
  [LOOKUP_REFERENCES]: 1,
  [COLLECTION_REFERENCES]: 2,
  [PRODUCT_RECOMMENDATIONS]: 3,
  // Smart ingest
  [SMART_INGEST_METRICS.productionSyncsCount]: 1,
  [SMART_INGEST_METRICS.testSyncsCount]: 2,
};
